module.exports = __webpack_public_path__ + "img/bg_lab_night.cee292c4.jpg";